export class User {
  public UserName: string;
  public PWD: string;
  public department: string;
  public role: string;
  public tel: string;
  constructor() {
    this.UserName = "";
    this.PWD = "";
  }
}
